import { Type } from '@angular/core';
import { FORM_DEFINITION_METADATA_KEY } from './metadata-keys';
import { DxFormGroup } from '../form-group';
import { setMetadata } from '@digitaix/helpers';

export function FormDefinition<FG extends DxFormGroup<any, any, any>>(
  group: Type<FG>,
) {
  return function(target: any) {
    setMetadata(FORM_DEFINITION_METADATA_KEY, group, target);
  };
}
